/** Apple exports MM/DD/YYYY zero-padded; the bank exports M/D/YYYY unpadded. */
export function parseUsDate(value: string): string {
  const m = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/.exec(value);
  if (!m) throw new Error(`Unrecognized date: "${value}"`);
  const [, mm, dd, yyyy] = m;
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

/** Returns SIGNED INTEGER CENTS. Handles '.00', '$1,207.70', '', '5.9', '35'. */
export function parseAmountCents(value: string): number {
  const cleaned = (value ?? '').replace(/[$,\s]/g, '');
  if (cleaned === '') return 0;
  const m = /^(-?)(\d*)(?:\.(\d{0,2}))?$/.exec(cleaned);
  if (!m) throw new Error(`Unrecognized amount: "${value}"`);
  const [, sign, whole, frac] = m;
  const cents = Number(whole || '0') * 100 + Number(((frac ?? '') + '00').slice(0, 2));
  return sign === '-' ? -cents : cents;
}

/**
 * Synchronous 64-bit hash (two FNV-1a passes with different primes, concatenated).
 *
 * Deliberately not SHA: crypto.subtle is async, and this must be callable from a
 * pure synchronous function a unit test can drive. Hex output is also RTDB-key-safe,
 * which matters because raw descriptions contain '.', '#', '$', '/', '[' and ']' —
 * all illegal in Realtime Database keys.
 */
export function hash64(input: string): string {
  let h1 = 0x811c9dc5;
  let h2 = 0xcbf29ce4;
  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 0x01000193) >>> 0;
    h2 = Math.imul(h2 ^ c, 0x85ebca6b) >>> 0;
  }
  return h1.toString(16).padStart(8, '0') + h2.toString(16).padStart(8, '0');
}
